(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pinkline-privacy-open]');
    if (!button) return;
    const message = document.getElementById(button.getAttribute('aria-describedby'));
    message.hidden = true;
    button.disabled = true;
    try {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
        throw new Error('Privacy preferences unavailable');
      }
      await window.privacyBanner.showPreferences();
    } catch {
      message.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
